import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useScreen } from '../../app/shell-context';
import { formatKop } from '../../lib/money';
import { plural } from '../../lib/plural';
import { Notice, Opt } from '../../ui/parts';
import { useBooking, useBookingGuard } from '../BookingContext';
import { useServices } from '../api';

/** Шаг 2 из 5: услуги закреплённого специалиста. */
export function Service() {
  const navigate = useNavigate();
  const { patch } = useBooking();
  const booking = useBookingGuard((b) => b.specialistId !== null);
  const services = useServices(booking?.specialistId ?? null);

  useScreen('Формат записи', {
    label: 'Далее',
    disabled: !booking?.serviceId,
    onClick: () => navigate('/calendar'),
  });

  if (!booking) return null;

  return (
    <Screen>
      <div>
        <p className="eyebrow">Шаг 2 из 5</p>
        <p className="lead" style={{ marginTop: 6 }}>
          Формат записи · {booking.specialistName}. От него зависят длительность и свободные окна.
        </p>
      </div>

      {services.isPending ? <p className="lead">Загружаем услуги…</p> : null}

      <div className="options">
        {(services.data ?? []).map((s) => (
          <Opt
            key={s.serviceId}
            pressed={booking.serviceId === s.serviceId}
            title={s.title}
            aside={<span>{formatKop(s.priceKop)}</span>}
            note={`${s.durationMin} ${plural(s.durationMin, 'минута', 'минуты', 'минут')}, ${s.isOnline ? 'видеосвязь' : 'очно'}.`}
            onClick={() =>
              patch({
                serviceId: s.serviceId,
                serviceTitle: s.title,
                durationMin: s.durationMin,
                priceKop: s.priceKop,
                isOnline: s.isOnline,
                startsAt: null,
              })
            }
          />
        ))}
      </div>

      {services.data && services.data.length === 0 ? (
        <Notice kind="calm">
          У специалиста пока нет услуг, доступных для записи. Напишите администратору организации.
        </Notice>
      ) : null}
    </Screen>
  );
}
